import React from "react";
import styles from "./TestimonialItem.module.css";
import PropTypes from "prop-types";
import image from "../../assets/pilot-graphic.png"

export const TestimonialItem=({ quote, name, company })=> {
    return (
        <div>
            <div className={styles.descriptionContainer}>
                <div className={styles.quoteBox}>
                    <p className={styles.quote}>{quote}</p>
                </div>            
            </div>
            <div className={styles.authorInfo}>
                <div>
                    <img src={image} alt="Pilot profile" />
                </div>
                <div>
                    <p className={styles.authorName}>{name}</p>
                    <p className={styles.company}>{company}</p>
                </div>
            </div>
        </div>
  );
}


TestimonialItem.propTypes ={
    quote: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    company: PropTypes.string.isRequired
}